export default __webpack_public_path__ + "static/Noroutine_Candidate_Privacy_Notice-6104a7f1e5554e9e6c6a6b8277352b1b.pdf";